import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PlaybookComponent } from './playbook/playbook.component';

const routes: Routes = [
  {
    path: ':playbookId',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/section/:sectionId',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/section/:sectionId/tab/:tabId',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/ratings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/ratings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/section/:sectionId/ratings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/resource/:resourceId/resourceRatings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/resource/:resourceId/resourceRatings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/section/:sectionId/resource/:resourceId/resourceRatings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/folder/:folderId/folderRatings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/folder/:folderId/folderRatings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/section/:sectionId/folder/:folderId/folderRatings',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/pagetemplate/choose',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/section/:sectionId/pagetemplate/choose',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/pagetemplate',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: ':playbookId/page/:pageId/section/:sectionId/pagetemplate',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: 'playbook/:playbookId/selectTranslation',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: 'playbook/:playbookId/page/:pageId/selectTranslation',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  },
  {
    path: 'playbook/:playbookId/page/:pageId/section/:sectionId/selectTranslation',
    component: PlaybookComponent,
    data: { title: 'vPlaybook' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class PlaybookEditorRoutingModule { }
